/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  getForConversation(conversationId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`
    );
  }

  createForConversation({ conversationId, content, scheduledAt }) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`,
      { scheduled_message: { content, scheduled_at: scheduledAt } }
    );
  }

  cancelForConversation({ conversationId, id }) {
    return axios.delete(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${id}`
    );
  }

  getAll({ page = 1, status } = {}) {
    return axios.get(this.url, { params: { page, status } });
  }
}

export default new ScheduledMessagesAPI();
